/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Failed_ExpiredInputs */

const en_password_reset_failed_expired = /** @type {(inputs: Password_Reset_Failed_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password reset failed. The link may have expired.`)
};

const es_password_reset_failed_expired = /** @type {(inputs: Password_Reset_Failed_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al restablecer la contraseña. El enlace puede haber expirado.`)
};

/**
* | output |
* | --- |
* | "Password reset failed. The link may have expired." |
*
* @param {Password_Reset_Failed_ExpiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_failed_expired = /** @type {((inputs?: Password_Reset_Failed_ExpiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Failed_ExpiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_failed_expired(inputs)
	return en_password_reset_failed_expired(inputs)
});